import React from "react";

export default function ML_Deep_Learning() {
  return (
    <div>
      <h1>ML_Deep_Learning</h1>
      <p>This is the ML_Deep_Learning component.</p>
    </div>
  );
}
